import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Usuario from '../supabase/Usuario';
import { useAuth } from '../../context/AuthContext';
import './Login.css';
import logo from './logo.png';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [usuario, setUsuario] = useState('');
  const [contrasenna, setContrasenna] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Manejar el Login de usuario, falta la parte de "olvidé mis credenciales"
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const numDocumento = await Usuario.getNumDocumentoPorUsuario(usuario);
      if (!numDocumento) {
        setError('Usuario no encontrado');
        return;
      }

      const ok = await Usuario.login(numDocumento, contrasenna);
      if (ok) {
        login(numDocumento);
        navigate('/home');
      } else {
        setError('Credenciales inválidas');
      }
    } catch (err) {
      setError('No se pudo iniciar sesión. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="app-container">
          <div className="login-page">
          <header className="login-header" role="banner">
            <div className="brand">
              <img src={logo} className="brand-logo" alt="Logo reANIDArt - Muestra 1 pájaro con dos polluelos en un nido de ramas con hojas alrededor" />
              <h1 className="brand-title" id="login-title">reANIDArt</h1>
            </div>
              <title>ReANIDArt - Login</title>
          </header>

          <main className="login-main" role="main" aria-labelledby="login-title">
            <form className="login-card" onSubmit={handleSubmit} aria-describedby={error ? 'login-error' : undefined}>
              <label className="field">
                <span>Usuario</span>
                <input
                  type="text"
                  placeholder="Usuario"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                  required
                  autoComplete="username"
                />
              </label>

              <label className="field">
                <span>Contraseña</span>
                <div className="password-wrapper">
                  <input
                    type={showPass ? 'text' : 'password'}
                    placeholder="Contraseña"
                    value={contrasenna}
                    onChange={(e) => setContrasenna(e.target.value)}
                    required
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="toggle-pass"
                    onClick={() => setShowPass((s) => !s)}
                    aria-label={showPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                  >
                    {showPass ? '🚫' : '👁️'}
                  </button>
                </div>
              </label>

              <button type="button" className="link-forgot" onClick={() => alert('Pronto...')}>
                Olvidé mis credenciales
              </button>

              {error && <div id="login-error" className="error" role="alert" aria-live="assertive">{error}</div>}

              <div className="actions">
                <button type="submit" className="btn primary" disabled={loading}>
                  {loading ? 'Ingresando...' : 'Iniciar sesión'}
                </button>
                <button type="button" className="btn" onClick={() => navigate('/register')}>
                  Crear cuenta
                </button>
              </div>
            </form>
          </main>
        </div>
      </div>
  );
}
